module.exports = __webpack_public_path__ + "media/images/slide1-5cfeb95a4244624b1436c70ff9939e0a.jpg";